/** System pseudo-categories shown in the sidebar. Filtering and counts are server-owned. */

export type SystemCategoryId =
  | 'dead_links'
  | 'broken_links'
  | 'bot_protected'
  | 'failed'
  | 'low_confidence'
  | 'fetch_failed';

export interface SystemCategory {
  id: SystemCategoryId;
  label: string;
}

export const SYSTEM_CATEGORIES: SystemCategory[] = [
  { id: 'dead_links', label: 'Dead links' },
  { id: 'broken_links', label: 'Broken links' },
  { id: 'bot_protected', label: 'Bot protected' },
  { id: 'failed', label: 'Awaiting / failed' },
  { id: 'low_confidence', label: 'Low confidence' },
  { id: 'fetch_failed', label: 'Fetch failed' },
];
